/**
 * Stub: CompetitorAnalysisView is not available in the admin app.
 * This stub exists so that @a7y/ui EngineDetailCompetitor can be resolved by the bundler.
 */
export const CompetitorAnalysisView = () => null;
